import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ShippingPage() {
  return (
    <div className="min-h-screen bg-[#FDFAF8]">
      <Navbar />

      <main>
        {/* Header */}
        <div className="bg-[#1A1A1A] py-14 md:py-20">
          <div className="w-full px-4 md:px-8 lg:px-12 max-w-4xl mx-auto text-center">
            <h1 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] mb-3">
              Shipping & Delivery
            </h1>
            <p className="font-body text-sm text-[#999999]">
              Last updated: June 2026
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 max-w-3xl mx-auto">
          {/* Delivery Times */}
          <section className="mb-12">
            <h2 className="font-heading text-xl md:text-2xl text-[#1A1A1A] mb-4">
              Delivery Times
            </h2>
            <div className="w-16 h-px bg-[#C9A84C] mb-6" />
            <p className="font-body text-sm text-[#555555] leading-relaxed mb-4">
              All orders are processed within 1–2 business days (excluding weekends and holidays). Once your order ships, you will receive a confirmation email with tracking details.
            </p>
            <div className="bg-[#1A1A1A]/5 rounded-lg p-5 md:p-6">
              <table className="w-full text-sm font-body">
                <thead>
                  <tr className="border-b border-[#C9A84C]/30">
                    <th className="text-left text-[#1A1A1A] font-medium py-2 pr-4">Region</th>
                    <th className="text-left text-[#1A1A1A] font-medium py-2">Estimated Delivery</th>
                  </tr>
                </thead>
                <tbody className="text-[#555555]">
                  <tr className="border-b border-[#1A1A1A]/10">
                    <td className="py-3 pr-4">Lagos & Abuja (Metro)</td>
                    <td className="py-3">1–3 business days</td>
                  </tr>
                  <tr className="border-b border-[#1A1A1A]/10">
                    <td className="py-3 pr-4">Other Nigerian Cities</td>
                    <td className="py-3">3–7 business days</td>
                  </tr>
                  <tr className="border-b border-[#1A1A1A]/10">
                    <td className="py-3 pr-4">Ghana, Kenya, South Africa</td>
                    <td className="py-3">5–10 business days</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4">UK, US, Europe, Rest of World</td>
                    <td className="py-3">7–14 business days</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Shipping Costs */}
          <section className="mb-12">
            <h2 className="font-heading text-xl md:text-2xl text-[#1A1A1A] mb-4">
              Shipping Costs
            </h2>
            <div className="w-16 h-px bg-[#C9A84C] mb-6" />
            <p className="font-body text-sm text-[#555555] leading-relaxed mb-4">
              We offer flat-rate shipping based on your location. Shipping is automatically calculated at checkout before you complete your payment.
            </p>
            <ul className="space-y-3 font-body text-sm text-[#555555]">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#C9A84C] mt-1.5 shrink-0" />
                <span><strong className="text-[#1A1A1A]">Nigeria:</strong> NGN 2,500 flat rate. Free shipping on orders over NGN 50,000.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#C9A84C] mt-1.5 shrink-0" />
                <span><strong className="text-[#1A1A1A]">West Africa (Ghana, Benin, Togo):</strong> NGN 5,000 flat rate.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#C9A84C] mt-1.5 shrink-0" />
                <span><strong className="text-[#1A1A1A]">Rest of Africa:</strong> NGN 7,500 flat rate.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#C9A84C] mt-1.5 shrink-0" />
                <span><strong className="text-[#1A1A1A]">UK, US, Europe:</strong> NGN 12,000 flat rate.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#C9A84C] mt-1.5 shrink-0" />
                <span><strong className="text-[#1A1A1A]">Rest of World:</strong> Calculated at checkout based on destination.</span>
              </li>
            </ul>
          </section>

          {/* Packaging */}
          <section className="mb-12">
            <h2 className="font-heading text-xl md:text-2xl text-[#1A1A1A] mb-4">
              Packaging & Care
            </h2>
            <div className="w-16 h-px bg-[#C9A84C] mb-6" />
            <p className="font-body text-sm text-[#555555] leading-relaxed mb-4">
              Your H.O.M.E Collection arrives in a thoughtfully designed branded box, cushioned with tissue paper to protect the journal and card deck during transit. Each set is inspected and sealed before shipping.
            </p>
            <p className="font-body text-sm text-[#555555] leading-relaxed">
              If you are gifting the set, you can add a personalised handwritten note at checkout. The outer packaging is plain for privacy, no branding on the outside.
            </p>
          </section>

          {/* Tracking */}
          <section className="mb-12">
            <h2 className="font-heading text-xl md:text-2xl text-[#1A1A1A] mb-4">
              Order Tracking
            </h2>
            <div className="w-16 h-px bg-[#C9A84C] mb-6" />
            <p className="font-body text-sm text-[#555555] leading-relaxed mb-4">
              Once your order is dispatched, you will receive an email with a tracking number and a link to monitor your shipment in real time. You can also track your order by contacting us at{' '}
              <a href="mailto:MANDIEOZEE@GMAIL.COM" className="text-[#D4006A] hover:underline">
                MANDIEOZEE@GMAIL.COM
              </a>{' '}
              with your order number.
            </p>
          </section>

          {/* Delivery Issues */}
          <section className="mb-12">
            <h2 className="font-heading text-xl md:text-2xl text-[#1A1A1A] mb-4">
              Missed Deliveries & Failed Attempts
            </h2>
            <div className="w-16 h-px bg-[#C9A84C] mb-6" />
            <p className="font-body text-sm text-[#555555] leading-relaxed mb-4">
              If our courier is unable to deliver after two attempts, your package will be held at the nearest local depot for collection. You will be notified via SMS and email with depot details and pickup instructions.
            </p>
            <p className="font-body text-sm text-[#555555] leading-relaxed">
              Packages uncollected after 7 days may be returned to sender. In such cases, please contact us to arrange redelivery (redelivery fees may apply).
            </p>
          </section>

          {/* International Orders */}
          <section className="mb-12">
            <h2 className="font-heading text-xl md:text-2xl text-[#1A1A1A] mb-4">
              International Orders
            </h2>
            <div className="w-16 h-px bg-[#C9A84C] mb-6" />
            <p className="font-body text-sm text-[#555555] leading-relaxed mb-4">
              International shipments may be subject to customs duties, import taxes, and handling fees determined by your country's regulations. These charges are the responsibility of the recipient and are not included in the shipping cost at checkout.
            </p>
            <p className="font-body text-sm text-[#555555] leading-relaxed">
              We ship with DHL, FedEx, and local courier partners depending on your location for the fastest and most reliable delivery.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="font-heading text-xl md:text-2xl text-[#1A1A1A] mb-4">
              Questions About Shipping?
            </h2>
            <div className="w-16 h-px bg-[#C9A84C] mb-6" />
            <p className="font-body text-sm text-[#555555] leading-relaxed mb-6">
              If you have any questions about delivery, tracking, or shipping to your location, please reach out. We are happy to help you get your H.O.M.E Collection into your hands.
            </p>
            <a
              href="mailto:MANDIEOZEE@GMAIL.COM"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 w-full sm:w-auto justify-center"
            >
              <i className="ri-mail-line" />
              Email Us
            </a>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}